import { render, staticRenderFns } from "./StatisticsChannel.vue?vue&type=template&id=217c9317&scoped=true&"
import script from "./StatisticsChannel.vue?vue&type=script&lang=js&"
export * from "./StatisticsChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c9317",
  null
  
)

export default component.exports